import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BarChart from 'components/BarChart';
import TicketTiersScannedBarGraph from '../TicketTiersScannedBarGraph';
import { useGetEventAnalyticsRevenueDaily } from 'legacy/events/hooks/useGetEventAnalyticsRevenueDaily';
import { useRouter } from 'next/router';
import { currencyFormat } from 'legacy/common/utils/currency';
import i18n from 'i18n';

// import DownloadCSVButton from '../DownloadCSVButton';

const KeyMetricsSection = () => {
  const { t } = useTranslation(['events']);
  const router = useRouter();
  const eventId = router.query.slug as string;

  const { data: revenueDaily } = useGetEventAnalyticsRevenueDaily({ eventId });

  const revenueDailyData = useMemo(() => {
    if (!revenueDaily || !revenueDaily.data || revenueDaily.data.length === 0) {
      return [];
    }

    return revenueDaily?.data?.map((item) => {
      const date = new Date(item.date);
      const formattedDate = date.toLocaleDateString(i18n.language, {
        month: 'short',
        day: 'numeric'
      });
      return {
        name: formattedDate,
        value: item.revenue,
        total: revenueDaily?.totalRevenue
      };
    });
  }, [revenueDaily]);

  return (
    <div>
      <div className="flex justify-between  mb-4 items-center">
        <h2 className="text-xl font-bold flex flex-row">
          <img src="/img/events/key-metrics.svg" alt="key-metrics" /> &nbsp;{' '}
          {t('events:dashboard.keyMetrics')}
        </h2>
        <div className="flex text-right">
          {/* <DownloadCSVButton
            onClick={onClickExportAnalytics}
            loading={isFetchingExportAnalytics}
          /> */}
        </div>
      </div>
      <div className="flex justify-between space-x-4">
        <TicketTiersScannedBarGraph />
        <BarChart
          data={revenueDailyData}
          className="w-1/2"
          title={t('events:dashboard.revenueLastDays', {
            count: revenueDaily?.data?.length || 5
          })}
          subtitle={`${currencyFormat(revenueDaily?.totalRevenue)}`}
          type="currency"
        />
      </div>
    </div>
  );
};

export default KeyMetricsSection;
